module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTJunupunuZemt5qmupunupmmt5qmuZ+fsZunupunupmlt5unuqSvwcrQ27a/zf7+/ubq7mjIflIAAAAMdFJOUwC/kCCA70FoENqoMCstz/wAAAD3SURBVDjLrVPbDoMgDBVoKZWi7v9/dgiTMnQuS9Ynk556Li3T9NfieN8nMbf9wCL+DmBFZL6Z3/uC4aLlgIgsSinSiUYXpKsmM7I0LHSAg4NQsPPfIWKb6QAOFUD6z06wVwAoJ7yFWCqJWIVjHBHLtuxjKgmcIrKtAqCMXdOBYOqUzoXCTyZtj4PEviVLXCQYWdbahlPwLpZfZdds7LhZ5334vEow+EopXJyEN1XStuZVmdQrrwZfktOSskR5rDIPXLvB6jrnIil75VEN6KJqjKfTKyrs/jWPlzUebFkKMp85oB0gXjgF9spGV5cdulS+vdDw24N+ArSLDojdxYKTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/logo.png
// module id = YbXv
// module chunks = 0